import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

export enum CruisePageCarouselSection {
  Deals = 'deals',
  TopOffers = 'topOffers',
  LuxPlusOffers = 'luxPlusOffers',
  CruiseLines = 'cruiseLines',
  Destinations = 'destinations',
  DepartingFrom = 'departingFrom',
  RoyalCaribbean = 'royalCaribbean',
  Departures = 'departures',
  ShortTerm = 'shortTerm',
  LongHaulOcean = 'longHaulOcean',
  LuxuryPremium = 'luxuryPremium',
  River = 'river',
  BestValue = 'bestValue',
  Expedition = 'expedition',
  CruiseTour = 'cruiseTour',
}

const CRUISE_PAGE_MEMBER_CAROUSEL_ORDER: Array<CruisePageCarouselSection> = [
  CruisePageCarouselSection.Deals,
  CruisePageCarouselSection.TopOffers,
  CruisePageCarouselSection.LuxPlusOffers,
  CruisePageCarouselSection.Destinations,
  CruisePageCarouselSection.DepartingFrom,
  CruisePageCarouselSection.Departures,
  CruisePageCarouselSection.LongHaulOcean,
  CruisePageCarouselSection.River,
  CruisePageCarouselSection.RoyalCaribbean,
  CruisePageCarouselSection.BestValue,
  CruisePageCarouselSection.LuxuryPremium,
  CruisePageCarouselSection.ShortTerm,
  CruisePageCarouselSection.CruiseLines,
  CruisePageCarouselSection.Expedition,
  CruisePageCarouselSection.CruiseTour,
]

const CRUISE_PAGE_NON_MEMBER_CAROUSEL_ORDER: Array<CruisePageCarouselSection> = [
  CruisePageCarouselSection.Deals,
  CruisePageCarouselSection.TopOffers,
  CruisePageCarouselSection.Destinations,
  CruisePageCarouselSection.DepartingFrom,
  CruisePageCarouselSection.Departures,
  CruisePageCarouselSection.LongHaulOcean,
  CruisePageCarouselSection.River,
  CruisePageCarouselSection.LuxPlusOffers,
  CruisePageCarouselSection.RoyalCaribbean,
  CruisePageCarouselSection.BestValue,
  CruisePageCarouselSection.LuxuryPremium,
  CruisePageCarouselSection.ShortTerm,
  CruisePageCarouselSection.CruiseLines,
  CruisePageCarouselSection.Expedition,
  CruisePageCarouselSection.CruiseTour,
]

interface CruisePageCarouselOrderOptions {
  isLuxPlusMember: boolean
}

export function getCruisePageContentOrder({
  isLuxPlusMember,
}: CruisePageCarouselOrderOptions): Array<CruisePageCarouselSection> {
  return isLuxPlusMember ?
    CRUISE_PAGE_MEMBER_CAROUSEL_ORDER :
    CRUISE_PAGE_NON_MEMBER_CAROUSEL_ORDER
}

export default function useCruisePageContentOrder(): Array<CruisePageCarouselSection> {
  const isLuxPlusMember = useAppSelector(getCanViewLuxPlusBenefits)

  return getCruisePageContentOrder({
    isLuxPlusMember,
  })
}
